// sales-page/src/App.jsx
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SalesPage from './pages/SalesPage.jsx';
import Checkout from './pages/Checkout.jsx';
import PartnerPitch from './pages/PartnerPitch.jsx';
import Success from './pages/Success.jsx';
import ThankYouPlan from './pages/ThankYouPlan.jsx';
import ThankYouBadge from './pages/ThankYouBadge.jsx';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main sales page — requires ?ref=CODE to render */}
        <Route path="/" element={<SalesPage />} />

        {/* Pre-checkout order summary — shown after plan selection */}
        <Route path="/checkout" element={<Checkout />} />

        {/* Post-checkout partner badge upsell — Stripe redirects here after payment */}
        <Route path="/partner-pitch" element={<PartnerPitch />} />

        {/* Post-payment success page — Stripe redirects here with ?type=plan|badge */}
        <Route path="/success" element={<Success />} />

        {/* Direct thank-you pages (accessible but normally reached via /success) */}
        <Route path="/thank-you/plan" element={<ThankYouPlan />} />
        <Route path="/thank-you/badge" element={<ThankYouBadge />} />

        {/* Fallback — anything else goes back to sales page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;